const nativeFetch = window.fetch.bind(window);

function isOwnOrigin(url: string): boolean {
	return !/^[a-z]+:\/\//i.test(url) || url.startsWith(window.location.origin);
}

function requestUrl(input: RequestInfo | URL): string {
	if (typeof input === 'string') return input;
	if (input instanceof URL) return input.toString();
	return input.url;
}

export function installAccessDeniedInterceptor() {
	window.fetch = async (...args: Parameters<typeof fetch>) => {
		const response = await nativeFetch(...args);

		if (response.status === 403 && isOwnOrigin(requestUrl(args[0]))) {
			if (!window.location.hash.startsWith('#/AccessDenied')) {
				window.location.hash = '/AccessDenied';
			}
			return new Promise<Response>(() => {});
		}

		return response;
	};
}
